export default __webpack_public_path__ + "static/media/avatars@3x.df876e81.png";